import React from "react";

import {
    FiCalendar,
    FiRefreshCw,
} from "react-icons/fi";


const ReportPeriodToolbar = ({
    fromDate,
    toDate,
    financialYear,

    onFromDateChange,
    onToDateChange,
    onFinancialYearChange,

    onReset,
}) => {
    return (
        <section className="purchase-report-common-toolbar">

            <div className="purchase-report-common-toolbar-title">
                <FiCalendar />

                <div>
                    <strong>
                        Report Period
                    </strong>

                    <span>
                        Applied to all purchase reports
                    </span>
                </div>
            </div>


            <div className="purchase-report-common-toolbar-fields">

                {/* FROM DATE */}

                <div className="purchase-report-common-field">
                    <label>
                        From Date
                    </label>

                    <input
                        type="date"
                        value={
                            fromDate || ""
                        }
                        onChange={(
                            event
                        ) =>
                            onFromDateChange?.(
                                event.target.value
                            )
                        }
                    />
                </div>


                {/* TO DATE */}

                <div className="purchase-report-common-field">
                    <label>
                        To Date
                    </label>

                    <input
                        type="date"
                        value={
                            toDate || ""
                        }
                        onChange={(
                            event
                        ) =>
                            onToDateChange?.(
                                event.target.value
                            )
                        }
                    />
                </div>


                {/* FINANCIAL YEAR */}

                <div className="purchase-report-common-field">
                    <label>
                        Financial Year
                    </label>

                    <input
                        type="text"
                        value={
                            financialYear || ""
                        }
                        placeholder="2026-27"
                        onChange={(
                            event
                        ) =>
                            onFinancialYearChange?.(
                                event.target.value
                            )
                        }
                    />
                </div>


                {/* RESET */}

                <div className="purchase-report-common-field purchase-report-common-field-action">

                    <button
                        type="button"
                        className="purchase-report-button"
                        onClick={
                            onReset
                        }
                    >
                        <FiRefreshCw />

                        Reset Period
                    </button>

                </div>

            </div>

        </section>
    );
};


export default ReportPeriodToolbar;